import React from 'react';
import styles from './Card.module.css';
import cn from 'classnames';

type CardProps = {
    children?: React.ReactNode | undefined;
    className?: string;
};

const Card = ({ children, className }: CardProps) => {
    return <div className={cn(styles.card, className)}>{children}</div>;
};

export default Card;
